import { store } from './store';

import { checkAuthorization } from './auth/actions';

export default () =>
  new Promise(() => {
    store.dispatch(checkAuthorization());
  });
